export default __webpack_public_path__ + "static/media/user.4d12d5ce.jpg";